import { Channel, Topic } from "../constants/index.js";
import { MessageBrokerUtils } from "../utils/index.js";
import { useCallback } from "react";

export const useNativeCommunicationHandlers = () => {
  const openBiometricSettings = useCallback(data => {
    MessageBrokerUtils.publish({
      channel: Channel.BIOMETRICS,
      topic: Topic.biometricSettings,
      headers: { publisher: "UAA" },
      data: data
    });
  }, []);

  return {
    openBiometricSettings
  };
};
